import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ButtonDirective} from "primeng/button";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-save-button',
  standalone: true,
  templateUrl: './save-button.html',
  imports: [
    ButtonDirective,
    TranslatePipe
  ],
  styleUrl: './save-button.scss'
})
export class SaveButton {
  @Input({required:true}) isSaving: any;
  @Input() disabled = false
  @Output() save = new EventEmitter<void>();

}
